/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { StreemApiSsoProviderFromJSON, StreemApiSsoProviderToJSON, } from './';
export function StreemApiGetSsoProviderResponseFromJSON(json) {
    return StreemApiGetSsoProviderResponseFromJSONTyped(json, false);
}
export function StreemApiGetSsoProviderResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'ssoProvider': !exists(json, 'sso_provider') ? undefined : StreemApiSsoProviderFromJSON(json['sso_provider']),
    };
}
export function StreemApiGetSsoProviderResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'sso_provider': StreemApiSsoProviderToJSON(value.ssoProvider),
    };
}
//# sourceMappingURL=StreemApiGetSsoProviderResponse.js.map